<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M5.96 15.92c4.7-1.92 4.82-8.08 6.9-9.85 1.96-1.35 3.83.47 4.82 3.01 1.04 2.68 1.2 4.61-.4 6.04-3.26 2.73-10.2 7.86-12.48 6.72-1.71-.88-3.47-4.01 1.17-5.9M19.01 12.8c.2.34.74.4 1.2.13.46-.26.67-.76.47-1.09-.21-.33-.74-.39-1.2-.12-.46.26-.67.75-.47 1.1M18 2.27c-.59-.5-1.58-.29-2.22.46-.64.75-.69 1.76-.12 2.25.59.5 1.58.29 2.22-.46.64-.75.7-1.76.1-2.25M17.69 6.72c.36.36 1.03.26 1.51-.23.49-.47.59-1.15.23-1.5-.36-.36-1.03-.26-1.52.22-.48.48-.58 1.16-.22 1.51ZM18.7 8.8c.32.33.95.28 1.41-.15.47-.41.6-1.03.28-1.37-.32-.34-.94-.29-1.41.14-.47.42-.6 1.03-.28 1.37ZM18.97 10.87c.25.35.83.36 1.3.04.48-.33.67-.88.43-1.23-.25-.35-.84-.36-1.31-.04-.48.33-.67.88-.42 1.23Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
